const timelineTitle = document.getElementById("timelineTitle");
const timelineList = document.getElementById("timelineList");
const timelineDescription = document.getElementById("timelineDescription");
function showElement(number) {
    Array.from(timelineTitle.children).forEach((title, num)=>{
        number >= num ? title.classList.add("done-section-timeline-title-detail-active") : title.classList.remove("done-section-timeline-title-detail-active");
    });
    Array.from(timelineList.children).forEach((list, num)=>{
        number >= num ? list.classList.add("done-section-timeline-detail-active") : list.classList.remove("done-section-timeline-detail-active");
    });
    Array.from(timelineDescription.children).forEach((desc, num)=>{
        number >= num ? desc.classList.add("done-section-timeline-description-detail-active") : desc.classList.remove("done-section-timeline-description-detail-active");
    });
}
function hoverElement(number) {
    Array.from(timelineTitle.children).forEach((title, num)=>{
        number >= num ? title.classList.add("done-section-timeline-title-detail-hover") : title.classList.remove("done-section-timeline-title-detail-hover");
    });
    Array.from(timelineList.children).forEach((list, num)=>{
        number >= num ? list.classList.add("done-section-timeline-detail-hover") : list.classList.remove("done-section-timeline-detail-hover");
    });
    Array.from(timelineDescription.children).forEach((desc, num)=>{
        number >= num ? desc.classList.add("done-section-timeline-description-detail-hover") : desc.classList.remove("done-section-timeline-description-detail-hover");
    });
}
function outElement() {
    Array.from(timelineTitle.children).forEach((title)=>{
        title.classList.remove("done-section-timeline-title-detail-hover");
    });
    Array.from(timelineList.children).forEach((list)=>{
        list.classList.remove("done-section-timeline-detail-hover");
    });
    Array.from(timelineDescription.children).forEach((desc)=>{
        desc.classList.remove("done-section-timeline-description-detail-hover");
    });
}
function reveal() {
    let descriptions = document.querySelectorAll(".done-section-timeline-title-detail");
    let buttons = document.querySelectorAll(".done-section-timeline-detail");
    for(let i = 0; i < descriptions.length; i++){
        let windowHeight = window.innerHeight;
        let elementTop = descriptions[i].getBoundingClientRect().top;
        let elementVisible = 250;
        if (elementTop < windowHeight - elementVisible) {
            descriptions[i].classList.add("done-section-timeline-title-detail-visible");
            buttons[i].classList.add("done-section-timeline-detail-active-mobile");
        } else {
            descriptions[i].classList.remove("done-section-timeline-title-detail-visible");
            buttons[i].classList.remove("done-section-timeline-detail-active-mobile");
        }
    }
}
window.addEventListener("scroll", reveal);
function showMore(className) {
    let details = document.getElementsByClassName(className);
    let button = document.getElementById("showMoreButton");
    for (detail of details)detail.style.display = "block";
    button.style.display = "none";
}

//# sourceMappingURL=entreprises-donner-stock.7bc886d5.js.map
